import TripOfALifetimeSection from './trip-of-a-lifetime-section';

export default TripOfALifetimeSection;
